import React from "react";
import { Typography, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "./TextDecrypt";
import Resume from "../../settings/resume.json";
import { FirstName, LastName } from "../../utils/getName";
import Skill from "../skill/Skill";

const useStyles = makeStyles(() => ({
  main: {
    maxWidth: "100vw",
    marginTop: "auto",
    marginBottom: "auto",
  },
  heading: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "@media (max-width: 450px)": {
      marginTop: "100px",
    },
  },
  name: {
    fontFamily: "Alkatra",
    "@media (max-width: 450px)": {
      fontSize: "1.5rem",
    },
  },
  jobs: {
    fontFamily: "Alkatra",
    "@media (max-width: 768px)": {
      fontSize: "3rem",
    },
    "@media (max-width: 450px)": {
      fontSize: "1.5rem",
    },
  },
}));

export const Content = () => {
  const classes = useStyles();

  return (
    <Container component="main" className={classes.main} maxWidth="md">
      <div className={classes.heading}>
        <Typography variant="h2" component="h2" className={classes.name}>
          <TextDecrypt text={`${FirstName} ${LastName}`} />
        </Typography>
        <Typography variant="h1" component="h1" className={classes.jobs}>
          <TextDecrypt
            style={{ marginBlockStart: "0rem" }}
            text={Resume.basics.job1}
          />
        </Typography>
        <Skill />
      </div>
    </Container>
  );
};
